import _ from 'lodash';
export default class CommonService {
	UUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			// eslint-disable-next-line
			var r = (Math.random() * 16) | 0,
				v = c === 'x' ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}

	mapByParam(param, data) {
		let map = {};
		for (let i = 0; i < data.length; i++) {
			let val = data[i][param];
			if (val) {
				map[val] = data[i];
			}
		}
		return map;
	}

	/*
	 * Extract $(xxx) params from code block
	 */
	extractScriptParams(string) {
		const regex = /\(\s*([^)]+?)\s*\)/g;
		let varsArray = [];
		let matches = regex.exec(string);
		let m = matches && matches[1];

		if (m) {
			varsArray = m.split(/,\s*/);
		}

		return _.uniq(varsArray).filter(i => i !== '');
	}

	/*
	 * Extract $(xxx) params from strings
	 */
	extractParams(string) {
		const regex = /\$\(([\w|$|-]+?)\)/g;
		let varsArray = [];
		let matches;
		while ((matches = regex.exec(string)) !== null) {
			if (varsArray.indexOf(matches[1]) < 0) varsArray.push(matches[1]);
		}
		return varsArray;
	}

	/*
	* Build Request param objects that are used across all templated connections and endpoints
	* */
	buildRequestParams(keys, data) {
		let obj = {};
		_.forEach(keys, key => {
			let val = data[key];
			if (val) {
				_.forEach(this.extractParams(val), prop => {
					obj[prop] = true;
				});
			}
		});
		let rParams = {};
		_.forEach(Object.keys(obj), param => {
			rParams[param] = {
				required: false,
				type: 'string',
				value: ''
			};
		});
		return rParams;
	}

	/*
	* Build Request template from param objects that are used across all templated connections and endpoints
	* */
	buildRequestTemplate(requestParams) {
		let tpl = {};
		let keys = Object.keys(requestParams);
		_.forEach(keys, param => {
			let pd = requestParams[param];
			let item = {
				required: pd.required,
				type: pd.type
			};
			if (pd.value !== undefined) {
				item.default = pd.value;
			}
			tpl[param] = item;
		});
		return tpl;
	}

	/*
	* Build Request test data from param objects that are used across all templated connections and endpoints
	* */
	buildRequestTestData(requestParams) {
		let tpl = {};
		let keys = Object.keys(requestParams);
		_.forEach(keys, param => {
			let pd = requestParams[param];
			if (pd && pd.value) {
				tpl[param] = pd.value;
			}
		});
		return tpl;
	}

	safelyParseJSON(json) {
		var parsed;
		try {
			parsed = JSON.parse(json);
		} catch (e) {
			console.error(e);
		}
		return parsed;
	}

	downloadObjectAsJson(exportObj, exportName) {
		var dataStr = 'data:text/json;charset=utf-8,' + JSON.stringify(exportObj, null, 2);
		var downloadAnchorNode = document.createElement('a');
		downloadAnchorNode.setAttribute('href', dataStr);
		downloadAnchorNode.setAttribute('download', exportName + '.json');
		downloadAnchorNode.click();
		downloadAnchorNode.remove();
	}
}



// WEBPACK FOOTER //
// ./src/services/CommonService.js